import { render, staticRenderFns } from "./JdsMeridianLayout.vue?vue&type=template&id=a2790802&"
import script from "./JdsMeridianLayout.vue?vue&type=script&lang=ts&"
export * from "./JdsMeridianLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports